/**
 * Asynchronously loads the component for PrivacyPolicy
 */

import { lazyLoad } from "utils/loadable";

export const PrivacyPolicy = lazyLoad(
  () => import("./index"),
  (module) => module.PrivacyPolicy
);
